/* Bicimlendirme yardimcilari. Tum uygulama ayni para ve tarih dilini konusur. */

const currencyCache = new Map<string, Intl.NumberFormat>();

/** Para bicimi. Backend tutarlari `decimal(18,4)` olarak gonderir. */
export function money(value: number | null | undefined, currency = 'TRY'): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '—';
  }

  let formatter = currencyCache.get(currency);

  if (!formatter) {
    formatter = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    currencyCache.set(currency, formatter);
  }

  return formatter.format(value);
}

const numberFormat = new Intl.NumberFormat('tr-TR');

export function number(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : numberFormat.format(value);
}

export function percent(value: number | null | undefined, fractionDigits = 0): string {
  if (value === null || value === undefined) return '—';
  return `%${value.toFixed(fractionDigits).replace('.', ',')}`;
}

const dateFormat = new Intl.DateTimeFormat('tr-TR', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

const dateTimeFormat = new Intl.DateTimeFormat('tr-TR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Sunucu saatleri UTC'dir ama bazi alanlar sonunda `Z` tasimaz.
 * Eksikse eklenir; aksi hâlde tarayici yerel saat sanip kaydirirdi.
 */
function parse(value: string | null | undefined): Date | null {
  if (!value) return null;

  const normalized = /[Zz]|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`;
  const date = new Date(normalized);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value: string | null | undefined): string {
  const date = parse(value);
  return date ? dateFormat.format(date) : '—';
}

export function formatDateTime(value: string | null | undefined): string {
  const date = parse(value);
  return date ? dateTimeFormat.format(date) : '—';
}

/** "3 gün önce" gibi goreli ifade. */
export function relativeTime(value: string | null | undefined): string {
  const date = parse(value);
  if (!date) return '—';

  const diffSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  const rtf = new Intl.RelativeTimeFormat('tr-TR', { numeric: 'auto' });

  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['year', 31_536_000],
    ['month', 2_592_000],
    ['day', 86_400],
    ['hour', 3_600],
    ['minute', 60],
  ];

  for (const [unit, seconds] of units) {
    if (Math.abs(diffSeconds) >= seconds) {
      return rtf.format(Math.round(diffSeconds / seconds), unit);
    }
  }

  return rtf.format(diffSeconds, 'second');
}

/** Tarih girisi (input[type=date]) icin ISO gun bicimi. */
export function toDateInput(value: string | Date | null | undefined): string {
  const date = value instanceof Date ? value : parse(value ?? null);
  if (!date) return '';
  return date.toISOString().slice(0, 10);
}

export function initials(name: string | null | undefined): string {
  if (!name) return '?';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toLocaleUpperCase('tr-TR') ?? '')
    .join('');
}

/** Uzun metni kirpar. */
export function truncate(value: string | null | undefined, max = 80): string {
  if (!value) return '';
  return value.length <= max ? value : `${value.slice(0, max - 1)}…`;
}
